<template>
  <div class="min-h-screen flex items-center justify-center animate-fade-in">
    <div class="glass rounded-xl p-8 w-[460px] max-w-[90vw]">
      <!-- TestDrive Branding -->
      <div class="text-center mb-8">
        <div class="flex justify-center mb-4">
          <img src="/svg-cons/testdrive-logo-no-badge.png" alt="TestDrive" class="h-16 w-auto" />
        </div>
        <div
          class="w-24 h-px bg-gradient-to-r from-transparent via-slate-500 to-transparent mx-auto"
        ></div>
      </div>

      <!-- Sign In Content -->
      <div class="text-center mb-6">
        <p class="text-slate-400 text-sm leading-relaxed">
          Sales Engineering TEMS<br />
          Test Equipment Management System
        </p>
      </div>

      <div v-if="auth0Store.isLoading" class="text-center py-4">
        <div class="text-slate-300">Loading...</div>
      </div>

      <div v-else-if="auth0Store.error" class="text-red-400 text-sm mb-4 text-center">
        {{ auth0Store.error.message }}
      </div>

      <div v-else>
        <button
          @click="handleSignIn"
          class="w-full px-6 py-4 btn-primary rounded-lg font-semibold text-lg shadow-lg hover:shadow-xl transition-all duration-200"
        >
          Sign In to Test<em>Drive</em>
        </button>

        <div class="mt-6 text-center">
          <p class="text-xs text-slate-400">Secure authentication with multi-factor support</p>
          <p class="text-xs text-slate-500 mt-1">Powered by Auth0</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuth0Store } from '@/stores/auth0'

const auth0Store = useAuth0Store()
const route = useRoute()
const router = useRouter()

const redirectTarget = computed(() => {
  const requested = String(route.query.redirect || '/dashboard')
  return requested.startsWith('/') ? requested : '/dashboard'
})

async function handleSignIn() {
  await auth0Store.login(redirectTarget.value)
}

watch(
  () => auth0Store.isAuthenticated,
  (authenticated) => {
    if (authenticated) {
      router.replace(redirectTarget.value)
    }
  },
  { immediate: true },
)
</script>
